import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Carousel, message } from "antd";
import "./index.less";
import point_l from "@/images/home/point_l.png";
import point_r from "@/images/home/point_r.png";
import list1 from "@/images/home/list1.png";
import list2 from "@/images/home/list2.png";
import list3 from "@/images/home/list3.png";
import air from "@/images/home/air.png";
import { homeApi } from "@/apis";
import { useUserInfo, useUserInfoDispath } from "@/model";

const defaultUrl = {
  fileCode: "feb15a86-e084-4b03-9485-84ce3cfb01bb",
  defaultUrl:
    "https://shop.yingde.com/crm-venus/v1/venus/files/download/feb15a86-e084-4b03-9485-84ce3cfb01bb.id",
};

const Home = () => {
  const userInfo = useUserInfo();
  const dispatch = useUserInfoDispath();
  const location = useLocation();
  // const [bannerList, setBannerList] = useState<BannerList[]>([defaultUrl]);
  const [bannerList, setBannerList] = useState<BannerList[]>([]);

  useEffect(() => {
    // 重置密码后的回到首页
    const query = new URLSearchParams(location.search);
    const needlogin = query.get("needlogin");

    const params: HomeBannerParams = { pageSize: 10, type: "10" };
    if (userInfo.curUserInfo) {
      params.account = userInfo.curUserInfo.userAccount;
    } else {
      params.productGroupCode = "XN";
      if (needlogin) {
        dispatch({ type: "login/open" });
      }
    }
    homeApi
      .getBannerList(params)
      .then((res) => {
        const { records } = res;
        const _records = records.filter(
          (el) => el.fileCode !== defaultUrl.fileCode
        );
        // setBannerList([defaultUrl, ..._records]);
        setBannerList(records);
      })
      .catch((err) => {
        message.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.curUserInfo]);

  return (
    <div className="home-wrapper">
      <div className="banner-wrapper">
        <div className="banner-content">
          <Carousel className="banner-carousel" autoplay>
            {bannerList.map((el) => (
              <div key={el.defaultUrl || `${el.fileCode}_1`}>
                <img
                  src={
                    el.defaultUrl ||
                    `/crm-venus/v1/venus/files/download/${el.fileCode}.id`
                  }
                  alt=""
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
      <div className="max-width">
        <div className="home-info">
          <div className="home-info-title flex-c-c">
            <img src={point_l} alt="" />
            <span>气体应用</span>
            <img src={point_r} alt="" />
          </div>
          <div className="home-info-box">
            <div className="home-info-body">
              <h3>
                氧气O<span className="text-12">2</span>
              </h3>
              <p className="home-info-body-main">
                氧气应用广泛，因其强氧化性和助燃性，在各类工业过程可减少燃料使用量并降低二氧化碳排放量，
                进而提高效率；在环保行业则将其广泛应用于水处理和环境保护领域。
              </p>
              <ul>
                <li>
                  <span className="title">冶金行业</span>
                  <span>提高金属生产的燃烧效率和产品品质</span>
                </li>
                <li>
                  <span className="title">水处理</span>
                  <span>提高水处理能力、减少异味、降低噪音、臭氧杀菌</span>
                </li>
                <li>
                  <span className="title">玻璃与陶瓷</span>
                  <span>提高热效率、减少热损失、减少污染和排放</span>
                </li>
                <li>
                  <span className="title">化工行业</span>
                  <span>提高生产效率、充当原料氧化剂</span>
                </li>
                <li>
                  <span className="title">航天事业/深海作业</span>
                  <span>助燃剂、氧化剂、潜水作业</span>
                </li>
                <li>
                  <span className="title">医药与保健</span>
                  <span> 呼吸供给、医疗抢救</span>
                </li>
              </ul>
              <div className="home-info-footer">
                <div>
                  <img src={air} alt="" />
                  <span>液氧</span>
                </div>
                <div>
                  <img src={air} alt="" />
                  <span>高纯氧</span>
                </div>
                <div>
                  <img src={air} alt="" />
                  <span>医用氧</span>
                </div>
              </div>
            </div>
            <img src={list1} alt="" />
          </div>
          <div className="home-info-box shop-m-re">
            <img src={list2} alt="" />
            <div className="home-info-body">
              <h3>
                氮气N<span className="text-12">2</span>
              </h3>
              <p className="home-info-body-main">
                氮气是一种惰性气体，因其能够产生较低的温度，且具有无毒、无色、无味、不易燃易爆和化学物质稳定的特点，
                被广泛用于电子工业、科研、医疗和食品等多个领域，在大多数的应用中，氮气是作为一种物理的制冷剂或是一种化学的惰性气体。
              </p>
              <ul>
                <li>
                  <span className="title">医药/医学</span>
                  <span>低温医学冷冻剂</span>
                </li>
                <li>
                  <span className="title"> 电子产业 </span>
                  <span> 气氛保护载气</span>
                </li>
                <li>
                  <span className="title"> 食品与饮料 </span>
                  <span>食品速冻、食品饮料加工食品存储保鲜</span>
                </li>
                <li>
                  <span className="title"> 化工与石油化工 </span>
                  <span>清除废气、精细化工冷却、输送和保护</span>
                </li>
                <li>
                  <span className="title"> 畜牧业 </span>
                  <span>
                    动物胚胎移植与存储、超低温收藏微生物技术农业生物基因存储、疫苗生产存储
                  </span>
                </li>
                <li>
                  <span className="title"> 其它应用领域 </span>
                  <span>制造与装配领域、金属热处理、氮气井下灭火</span>
                </li>
              </ul>
              <div className="home-info-footer">
                <div>
                  <img src={air} alt="" />
                  <span>液氮</span>
                </div>
                <div>
                  <img src={air} alt="" />
                  <span>食品氮</span>
                </div>
              </div>
            </div>
          </div>
          <div className="home-info-box last">
            <div className="home-info-body">
              <h3>氩气Ar</h3>
              <p className="home-info-body-main">
                氩气是空气中含量最多的稀有气体，无色、无味、无臭、无毒且化学性质极不活泼。因其化学物质稳定的特点，
                被作为保护气广泛应用于电子工业、黑色冶金及金属焊接等多个领域。
              </p>
              <ul>
                <li>
                  <span className="title">冶金业 </span>
                  <span>不锈钢、钛、硅、钨、铝</span>
                </li>
                <li>
                  <span className="title">保护气 </span>
                  <span>焊接、切割、3d打印</span>
                </li>
                <li>
                  <span className="title"> 载气 </span>
                  <span>集成电路制造、封装与测试</span>
                </li>
                <li>
                  <span className="title"> 填充气 </span>
                  <span>照明、双层玻璃</span>
                </li>
              </ul>
              <div className="home-info-footer">
                <div>
                  <img src={air} alt="" />
                  <span>液氩</span>
                </div>
              </div>
            </div>
            <img src={list3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
